var _linearGradient, _linearGradient2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "43.318485mm",
    height: "43.410137mm",
    viewBox: "0 0 43.318485 43.410138",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient12271"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop12267",
    offset: 0,
    style: {
      stopColor: "#606fa8",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop12269",
    offset: 1,
    style: {
      stopColor: "#5da2ca",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient12261"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#576c94",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop12257"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#5276b5",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop12259"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1323"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop1327",
    offset: 0,
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop1329",
    offset: 1,
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 0
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient12261",
    id: "linearGradient12263-6",
    x1: 117.90515,
    y1: 709.80933,
    x2: 118.85856,
    y2: 552.15741,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient12271",
    id: "linearGradient12265-7",
    gradientUnits: "userSpaceOnUse",
    x1: 108.77197,
    y1: 701.20038,
    x2: 125.29464,
    y2: 552.46558
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-763.95726,-25.08558)",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "aria-label": "G I S",
    transform: "matrix(0.20484516,0,0,0.20283038,1181.685,1020.877)",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "36.74278259px",
      lineHeight: 1.25,
      fontFamily: "Arial",
      InkscapeFontSpecification: "'Arial Bold'",
      letterSpacing: 0,
      wordSpacing: 0,
      display: "inline",
      opacity: 1,
      fill: "#576f92",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.6514945
    },
    id: "text4672-9-8-6-6-5-4-5-0-1-8-3-1"
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "B I S",
    transform: "matrix(0.27448511,0,0,0.27178537,752.6016,-124.78388)",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "36.74278259px",
      lineHeight: 1.25,
      fontFamily: "Arial",
      InkscapeFontSpecification: "'Arial Bold'",
      letterSpacing: 0,
      wordSpacing: 0,
      display: "inline",
      opacity: 1,
      fill: "url(#linearGradient12263-6)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.6514945
    },
    id: "text4672-4-4-0-9-2-5-5-5-9-0-0-0-6-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path979-4-7-6-0-7-5-6",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "36.74278259px",
      fontFamily: "Arial",
      InkscapeFontSpecification: "'Arial Bold'",
      fill: "url(#linearGradient12265-7)",
      fillOpacity: 1,
      strokeWidth: 4.6514945
    },
    d: "m 138.17925,656.4971 5.16696,-0.50234 q 0.46646,2.60142 1.88378,3.82139 1.43527,1.21998 3.85727,1.21998 2.56554,0 3.85728,-1.07645 1.30968,-1.09439 1.30968,-2.5476 0,-0.93292 -0.55617,-1.57879 -0.53822,-0.66381 -1.90172,-1.14821 -0.93292,-0.32293 -4.25197,-1.14821 -4.26992,-1.05851 -5.99224,-2.60142 -2.42201,-2.17084 -2.42201,-5.29254 0,-2.00937 1.13028,-3.74963 1.14821,-1.7582 3.28316,-2.67318 2.1529,-0.91498 5.1849,-0.91498 4.95166,0 7.44544,2.17084 2.51171,2.17084 2.63729,5.79488 l -5.31048,0.23323 q -0.34087,-2.02731 -1.47114,-2.90641 -1.11233,-0.89704 -3.35493,-0.89704 -2.31437,0 -3.62405,0.95086 -0.84322,0.60999 -0.84322,1.63262 0,0.93292 0.7894,1.59673 1.00469,0.84322 4.8799,1.7582 3.87522,0.91498 5.72312,1.90172 1.86584,0.96881 2.90641,2.67318 1.05851,1.68644 1.05851,4.18021 0,2.26055 -1.25586,4.23404 -1.25585,1.97348 -3.55228,2.94229 -2.29642,0.95086 -5.72312,0.95086 -4.98754,0 -7.66072,-2.29642 -2.67319,-2.31437 -3.19347,-6.72781 z m -19.19667,8.55777 v -26.30123 h 5.31048 v 26.30123 z M 82.41921,638.75364 h 10.513316 q 3.121701,0 4.64667,0.26911 1.54291,0.25117 2.744944,1.07645 1.21998,0.82528 2.02731,2.20672 0.80734,1.3635 0.80734,3.06788 0,1.8479 -1.00469,3.39081 -0.98674,1.54291 -2.691119,2.31437 2.404069,0.69969 3.695809,2.38613 1.29174,1.68643 1.29174,3.96492 0,1.79408 -0.84322,3.49845 -0.82528,1.68644 -2.27848,2.70907 -1.435269,1.00468 -3.552285,1.23791 -1.32762,0.14353 -6.40487,0.17941 H 82.41921 Z m 5.31048,4.37756 v 6.08193 h 3.480518 q 3.10376,0 3.857274,-0.0897 1.363502,-0.16147 2.134957,-0.93292 0.789396,-0.7894 0.789396,-2.0632 0,-1.21997 -0.681751,-1.97349 -0.66381,-0.77145 -1.99143,-0.93292 -0.789396,-0.0897 -4.539026,-0.0897 z m 0,10.45949 v 7.0328 h 4.915783 q 2.87053,0 3.641985,-0.16147 1.184093,-0.21529 1.919667,-1.04056 0.753514,-0.84322 0.753514,-2.24261 0,-1.18409 -0.574106,-2.00937 -0.574106,-0.82527 -1.668496,-1.20203 -1.076449,-0.37676 -4.700493,-0.37676 z m 50.63066,-36.58864 5.16695,-0.50235 q 0.46646,2.60142 1.88379,3.8214 1.43526,1.21997 3.85727,1.21997 2.56554,0 3.85727,-1.07645 1.30968,-1.09439 1.30968,-2.54759 0,-0.93292 -0.55616,-1.57879 -0.53823,-0.66381 -1.90173,-1.14821 -0.93292,-0.32294 -4.25197,-1.14822 -4.26991,-1.0585 -5.99223,-2.60141 -2.42201,-2.17084 -2.42201,-5.29254 0,-2.00937 1.13027,-3.74963 1.14821,-1.7582 3.28317,-2.67318 2.1529,-0.91499 5.18489,-0.91499 4.95167,0 7.44544,2.17084 2.51171,2.17084 2.6373,5.79488 l -5.31048,0.23324 q -0.34088,-2.02732 -1.47115,-2.90642 -1.11233,-0.89704 -3.35493,-0.89704 -2.31436,0 -3.62404,0.95087 -0.84322,0.60998 -0.84322,1.63261 0,0.93292 0.78939,1.59673 1.00469,0.84322 4.87991,1.7582 3.87521,0.91498 5.72311,1.90173 1.86585,0.9688 2.90642,2.67318 1.0585,1.68643 1.0585,4.18021 0,2.26054 -1.25585,4.23403 -1.25586,1.97349 -3.55228,2.94229 -2.29643,0.95087 -5.72312,0.95087 -4.98755,0 -7.66073,-2.29643 -2.67318,-2.31436 -3.19346,-6.7278 z m -19.19667,8.55776 v -26.30123 h 5.31048 v 26.30123 z m -26.355055,-9.67009 v -4.43138 h 11.446235 v 10.47743 q -1.66849,1.61467 -4.844016,2.85259 -3.157583,1.21997 -6.40487,1.21997 -4.126386,0 -7.194265,-1.72231 -3.067879,-1.74026 -4.610789,-4.95167 -1.54291,-3.22934 -1.54291,-7.01485 0,-4.10845 1.722318,-7.30192 1.722318,-3.19346 5.041368,-4.89784 2.529655,-1.30968 6.297225,-1.30968 4.897842,0 7.642789,2.0632 2.76288,2.04525 3.55228,5.66929 l -5.274601,0.98675 q -0.556165,-1.93761 -2.099075,-3.04994 -1.524969,-1.13027 -3.821393,-1.13027 -3.480517,0 -5.543711,2.20672 -2.045252,2.20672 -2.045252,6.5484 0,4.68255 2.081134,7.03279 2.081134,2.33231 5.454007,2.33231 1.668495,0 3.336991,-0.64587 1.686436,-0.66381 2.888471,-1.59673 v -3.33699 z m 53.100115,57.80965 c -4.6889,9.78404 -12.67249,22.79886 -23.68423,32.47985 l 3.22293,3.73613 c 11.76107,-10.34017 19.98338,-23.84998 24.87586,-34.059 z m -49.637488,1.09747 -4.25248,2.47498 c 7.050203,12.3586 13.698148,21.88479 25.886378,32.53753 l 3.21316,-3.75536 c -11.76986,-10.28692 -17.9145,-19.10512 -24.847058,-31.25715 z m 25.686228,-5.1225 c -22.497478,-0.31554 -39.021178,6.7904 -50.953117,18.67126 l 3.299077,3.38953 c 11.067384,-11.02004 26.088,-17.60683 47.58716,-17.30411 20.62631,0.29088 32.40545,5.35275 46.34818,17.04429 l 3.00324,-3.65921 c -14.45823,-12.12393 -27.88789,-17.84053 -49.28454,-18.14176 z m 2.09768,0.25045 h -4.90077 l 0.15133,37.47713 4.91054,-0.0493 z m 1.23948,-117.45923 -3.33716,3.84213 c 11.43986,10.14 20.65121,23.142 25.40993,33.15381 l 4.56686,-2.2048 c -5.11508,-10.76219 -14.60908,-24.12755 -26.63963,-34.79114 z m -6.43608,-0.30814 c -12.51092,11.02449 -20.168408,20.70647 -27.478808,33.62564 l 4.395516,2.53265 c 7.101462,-12.5494 14.220492,-21.5727 26.401402,-32.3063 z m -74.064726,77.3045 v 5.03623 H 197.63415 v -5.03623 z m 28.766117,-58.81614 -3.604185,3.59216 c 10.273125,10.52752 29.144452,20.71288 52.669054,20.31747 17.53519,-0.29581 34.82142,-5.4129 49.95236,-19.39305 l -3.4138,-3.77508 c -14.18095,13.10258 -29.98411,17.78629 -46.61472,18.06485 -22.02053,0.36977 -39.757834,-9.34672 -48.988709,-18.80635 z m 45.975699,-15.91724 -0.15133,38.9414 h 5.06285 l 0.15133,-38.9414 z m 0.74398,-3.30276 c -43.549967,0 -78.90887,35.78852 -78.90887,79.85638 0,44.06736 35.358903,79.86575 78.90887,79.86575 43.54948,-5e-4 78.90887,-35.79839 78.90838,-79.86575 4.9e-4,-44.06737 -35.3589,-79.85589 -78.90838,-79.85638 z m 0,5.91233 c 40.37781,4.9e-4 73.0542,33.06556 73.0542,73.94405 0,40.878 -32.67639,73.95292 -73.0542,73.95342 -40.378304,0 -73.054692,-33.07542 -73.054692,-73.95342 0,-40.87849 32.676388,-73.94405 73.054692,-73.94405 z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.25e259d98c638105eec8737289007438.svg";
export { ForwardRef as ReactComponent };